import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { AxiosError } from "axios";

export interface Orgao {
    id: number;
    nome: string;
    sigla: string;
}

export interface AvailableOrgaosResponse {
    available_orgaos: Orgao[];
}

export function useAvailableOrgaos() {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<AvailableOrgaosResponse, AxiosError<{ detail: string }>>({
        retry: false,
        enabled: !!token,
        queryKey: ['available-orgaos'],
        queryFn: async () => {
            const response = await apisiseci.get<AvailableOrgaosResponse>(
                `/profile-management/available-orgaos/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
    });
}
